import { Box, Button, CircularProgress, Typography } from "@mui/material"
import { useLocation, useNavigate } from "react-router"
import UsersTable from "./UsersTable"
import { useGetUsersQuery } from "@store/services"

function Users() {
  const navigate = useNavigate()
  const location = useLocation()
  const { data: usersData, isFetching } = useGetUsersQuery()

  const onAddClick = () => {
    navigate("/Administration/Users/new")
  }

  return (
    <Box className={"admin-users"} sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Users
      </Typography>
      {isFetching ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <UsersTable
            data={usersData?.items}
            onEditClick={(id) =>
              navigate(`/Administration/Users/${id}`, {
                state: { from: location },
              })
            }
          />
          <Box>
            <Button sx={{ mt: 1 }} variant="contained" onClick={onAddClick}>
              Add User
            </Button>
          </Box>
        </>
      )}
    </Box>
  )
}

export default Users
